import axios from 'axios';
import md5 from 'md5';
import { v4 as uuidv4 } from 'uuid';
import qs from 'qs';

// Sắp xếp key object
export const sortObjectByKey = (obj) => {
    const sortedKeys = Object.keys(obj).sort();
    const sortedObject = {};
    sortedKeys.forEach((key) => {
        sortedObject[key] = obj[key];
    });
    return sortedObject;
};

// Sinh headers x-api-*
export const getHeaders = (stime, secretKey, body = {}) => {
    const env = process.env.REACT_APP_APP_NODE;
    const data = qs.stringify(sortObjectByKey(body));
    const uuid = uuidv4();
    const client = md5(env + '-' + data + stime + uuid + secretKey);

    return {
        'x-api-stime': stime,
        'x-api-nonce': uuid,
        'x-api-client': client,
    };
};